import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { AGENCY, NAV_LINKS } from "../../data/content";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "backdrop-blur-xl bg-[#101318]/85 border-b border-[#2A303A]" : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <a href="#top" className="font-display text-lg md:text-xl font-bold tracking-tight" data-testid="nav-logo">
          Nordhorizont<span className="text-[#2E5BFF]"> Digital</span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#9AA3AF] hover:text-white transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s|ü/g, (m) => (m === "ü" ? "ue" : "-"))}`}
            >
              {l.label}
            </a>
          ))}
          <a href="#kontakt" className="btn-primary px-5 py-2.5 text-sm font-semibold" data-testid="nav-cta">
            {AGENCY.cta}
          </a>
        </nav>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menü" data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden px-6 pb-6 flex flex-col gap-4 bg-[#101318]/95 backdrop-blur-xl" data-testid="nav-mobile-menu">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base font-medium py-1 text-[#F2F4F7]">
              {l.label}
            </a>
          ))}
          <a href="#kontakt" onClick={() => setOpen(false)} className="btn-primary px-5 py-3 text-sm font-semibold text-center">
            {AGENCY.cta}
          </a>
        </nav>
      )}
    </header>
  );
};
